export enum SubscriptionCardModal {
  ADD_DELIVERY_TRANCHE,
  SUSPEND,
  ACTIVATE,
  PAY_AS_YOU_GO,
  PREMIUM_FEE,
  UPDATE_PREMIUM_PREFERENCES
}